import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Spinner, Alert } from 'react-bootstrap';
import api from '../../../config/roundrobinApi';

export default function QueueFormModal({ show, onHide, onCreated }) {
  const [name, setName] = useState('');
  const [viewId, setViewId] = useState('');
  const [viewName, setViewName] = useState('');
  const [views, setViews] = useState([]);
  const [interval, setInterval_] = useState(5);
  const [limit, setLimit] = useState('');
  const [comment, setComment] = useState('');
  const [commentMode, setCommentMode] = useState('private');
  const [loading, setLoading] = useState(false);
  const [loadingViews, setLoadingViews] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (show) {
      setLoadingViews(true);
      api.get('/zendesk/views')
        .then(res => setViews(res.data))
        .catch(() => setViews([]))
        .finally(() => setLoadingViews(false));
    }
  }, [show]);

  const handleViewChange = (e) => {
    const selectedId = e.target.value;
    setViewId(selectedId);
    const v = views.find(v => String(v.id) === selectedId);
    setViewName(v ? v.title : '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/queues', {
        name,
        zendesk_view_id: viewId,
        zendesk_view_name: viewName,
        run_interval_minutes: interval,
        limit_per_agent: limit ? parseInt(limit) : null,
        comment_text: comment,
        comment_mode: commentMode,
      });
      setName(''); setViewId(''); setViewName(''); setInterval_(5); setLimit(''); setComment(''); setCommentMode('private');
      onCreated();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to create queue');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>New Queue</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control value={name} onChange={e => setName(e.target.value)} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Zendesk View</Form.Label>
            {loadingViews ? <Spinner size="sm" /> : (
              <Form.Select value={viewId} onChange={handleViewChange} required>
                <option value="">Select a view...</option>
                {views.map(v => <option key={v.id} value={v.id}>{v.title}</option>)}
              </Form.Select>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Run Interval (minutes)</Form.Label>
            <Form.Control type="number" min={1} value={interval} onChange={e => setInterval_(parseInt(e.target.value) || 5)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Limit per Agent (optional)</Form.Label>
            <Form.Control type="number" min={0} value={limit} onChange={e => setLimit(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Comment</Form.Label>
            <Form.Control as="textarea" rows={2} value={comment} onChange={e => setComment(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Comment Mode</Form.Label>
            <Form.Select value={commentMode} onChange={e => setCommentMode(e.target.value)}>
              <option value="private">Private</option>
              <option value="public">Public</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? <><Spinner size="sm" className="me-1" />Creating...</> : 'Create'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
